import {Action} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {inject, injectable} from "inversify";

@injectable()
export class ShareActionOk extends Action<string | undefined> {
    @inject(TypesSocial.model)
    protected social: ISocial;

    async execute(): Promise<any> {
        const payload = {
            media: [
                {
                    type: "text",
                    text: `Никто не может победить ${this.social.me.name} в битве за территории`
                },
                {
                    type: "app-ref",
                    appId: 512000948950
                }
            ]
        };

        await this.social.share(payload);
    }
}
